const AUTH_SESSION_TOKEN_KEY = 'field-service-technique-auth-token';

function hasBrowserStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function getStoredSessionToken(): string | null {
  if (!hasBrowserStorage()) return null;
  const raw = window.localStorage.getItem(AUTH_SESSION_TOKEN_KEY);
  return raw?.trim() || null;
}

export function storeSessionToken(token: string | null): void {
  if (!hasBrowserStorage()) return;
  if (!token) {
    window.localStorage.removeItem(AUTH_SESSION_TOKEN_KEY);
    return;
  }
  window.localStorage.setItem(AUTH_SESSION_TOKEN_KEY, token);
}

export function clearStoredSessionToken(): void {
  storeSessionToken(null);
}

export function buildAuthenticatedHeaders(headers?: HeadersInit): Headers {
  const next = new Headers(headers);
  const token = getStoredSessionToken();
  if (token && !next.has('Authorization')) {
    next.set('Authorization', `Bearer ${token}`);
  }
  return next;
}
